import * as React from 'react';
import * as styles from '../../styles/form.module.scss';
import ReactMarkdown from 'react-markdown';

function FormSidebar({ icon, description }) {
  return (
    <div className={`card ${styles.formSidebar}`}>
      <img alt='icon' className='card-icon' src={icon || ''} width={100} />
      <ReactMarkdown>{description || ''}</ReactMarkdown>
    </div>
  );
}
export default FormSidebar;
